// Generated by GitHub Copilot
import { Type } from "class-transformer";
import { Displayable } from "#core/entities/shared/BaseModels.ts";
import { provesMfa, type LoginMethod } from "#core/auth/login-method.ts";
import type { MfaFactorType } from "#core/auth/mfa-factor-type.ts";

/** One second factor of the signed-in account, as listed by `GET /auth/account/me/mfa`. */
export default class MfaFactor extends Displayable {
    type!: MfaFactorType;
    /** Only a confirmed factor is asked for at login. */
    confirmed: boolean = false;
    @Type(() => Date)
    confirmed_at: Date | null = null;

    get formattedConfirmedAt(): string {
        return Displayable.formatDate(this.confirmed_at);
    }

    /** Removing a confirmed factor needs a session that proved MFA; a pending one goes from any session. */
    canBeRemovedIn(loginMethod: LoginMethod | null): boolean {
        return !this.confirmed || provesMfa(loginMethod);
    }
}
